<ng-container [formGroup]="fgParent">
  <mat-form-field [class.mat-form-field-invalid]="getClassInvalid()"
    class="example-full-width custom-autocomplete mat-form-field-invalid" (click)="openDrowDown(triggerAutoComplete)">
    <mat-label>{{ getLabelTranslation(summary.label) | i18n }}</mat-label>
    <input #triggerAutoComplete="matAutocompleteTrigger" matInput [matAutocomplete]="auto"
      [formControlName]="summary.techname" (focusout)="focusOut()" style="text-transform: uppercase;"/>
    <i class="material-icons align-arrow-right">arrow_drop_down</i>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="closeAutoComplete($event)">
      <mat-option *ngFor="let option of filteredOptions | async" [value]="option.value">{{ option.label }}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <mat-error style="font-size: 75%; position: relative;" *ngIf="getClassInvalid()">
    {{ 'mandatory_field' | i18n }}
  </mat-error>
</ng-container>